/**
 * Lean icon resolver — maps commonly used icon names to their Lucide components.
 * This avoids `import * as LucideIcons` which pulls the entire 200KB+ library.
 * Add new icons here as needed.
 */
import {
  Database, Users, LayoutGrid, Network, Share2, CloudUpload,
  Building2, User, Calendar, FileText, Shield, Star,
  Briefcase, CheckCircle, Award, Globe, Heart, Zap,
  TrendingUp, Target, Clock, Phone, Mail, MapPin,
  ArrowRight, ChevronRight, ExternalLink, Link,
  Layers, BarChart3, PieChart, Activity,
  BookOpen, GraduationCap, Handshake, Landmark,
  Rocket, Settings, Lock, Key, Eye,
  MessageSquare, MessageCircle, ThumbsUp,
  Headphones, LifeBuoy, HelpCircle,
  Plane, Ship, Train, Car,
  Home, Search, Filter, Tag,
} from "lucide-react";

const ICON_MAP = {
  Database, Users, LayoutGrid, Network, Share2, CloudUpload,
  Building2, User, Calendar, FileText, Shield, Star,
  Briefcase, CheckCircle, Award, Globe, Heart, Zap,
  TrendingUp, Target, Clock, Phone, Mail, MapPin,
  ArrowRight, ChevronRight, ExternalLink, Link,
  Layers, BarChart3, PieChart, Activity,
  BookOpen, GraduationCap, Handshake, Landmark,
  Rocket, Settings, Lock, Key, Eye,
  MessageSquare, MessageCircle, ThumbsUp,
  Headphones, LifeBuoy, HelpCircle,
  Plane, Ship, Train, Car,
  Home, Search, Filter, Tag,
};

/**
 * Resolve a Lucide icon component by name string.
 * @param {string} iconName - PascalCase icon name (e.g., "Users", "Database")
 * @returns {React.ComponentType|null}
 */
export const resolveIcon = (iconName) => {
  if (!iconName) return null;
  return ICON_MAP[iconName] || null;
};
